import { useAuth } from '../../../context/AuthContext';
import type { SchoolBranding } from '../types';
import { useUploadDataUrl } from './useUploadDataUrl';

/**
 * A school's branding in the shape the PDF renderer consumes. The logo is
 * pre-fetched into a data URL (useUploadDataUrl). Public pages, which have
 * no signed-in user, pass the school's name and logo filename from their own
 * response.
 *
 * `ready` is false while the logo loads so callers can hold their Download
 * button.
 */
export function useBranding(name: string | undefined, logo: string | null | undefined): { branding: SchoolBranding; ready: boolean } {
  const { dataUrl, ready } = useUploadDataUrl('logos', logo);
  return { branding: { name: name || 'School', logoDataUrl: dataUrl }, ready };
}

/** The signed-in user's school branding. */
export function useSchoolBranding(): { branding: SchoolBranding; ready: boolean } {
  const { user } = useAuth();
  return useBranding(user?.schoolId?.name, user?.schoolId?.logo);
}
